import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

const useQueryFarmDetail = (id?: string | number) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["FarmDetails", id],
    queryFn: () => fetchApi(`farmDetails?id=${id}`, token).get(),
    refetchOnWindowFocus: false,
  });
};

export default useQueryFarmDetail;
